'use client';

import { useCallback, type ComponentProps } from 'react';
import {
  TypeformSnippet,
  type TypeformSubmitEvent,
} from 'components/shared/TypeformSnippet';
import { trackPerformanceLabTypeformSubmit } from 'lib/analytics/trackPerformanceLabTypeformSubmit';

type PerformanceLabTypeformSnippetProps = ComponentProps<typeof TypeformSnippet>;

/** Typeform embed that pushes a dataLayer/gtag event on submit for Google Ads. */
export const PerformanceLabTypeformSnippet = ({
  onSubmit,
  ...props
}: PerformanceLabTypeformSnippetProps) => {
  const handleSubmit = useCallback(
    (event: TypeformSubmitEvent) => {
      trackPerformanceLabTypeformSubmit(event);
      onSubmit?.(event);
    },
    [onSubmit],
  );

  return <TypeformSnippet {...props} onSubmit={handleSubmit} />;
};
